const ui = {
  en: {
    nav: {
      home: 'Home',
      projects: 'Projects',
      contact: 'Contact',
      certifications: 'Certifications',
    },
    hero: {
      eyebrow: 'Diego Galán',
      title: 'Software Engineer building',
      highlight: 'AI-powered',
      titleEnd: 'products.',
      subtitle: 'I build scalable web applications, intelligent AI agents and interactive 3D experiences that solve real-world problems.',
      cta1: 'View my work',
      cta2: 'Contact me',
      ctaCv: 'Download CV',
    },
    chat: {
      placeholder: 'Ask me anything about Diego',
      send: 'Send',
      suggestions: [
        'What does Diego work on?',
        'Tell me a fun fact',
        'What technologies does he use?',
      ],
      error: 'Could not reply. Try again in a moment.',
    },
    experience: {
      heading: 'Experience',
      title: 'My journey building software products and interactive experiences.',
      t2018title: 'University Projects',
      t2018desc: 'Multimedia Engineering — VR games, 3D modeling and interactive experiences.',
      t2024title: 'Full Stack Developer',
      t2024desc: 'EasyPedido — Building full-stack functionality for ecommerce, reporting and real-time systems.',
      t2026title: 'VR Development',
      t2026desc: 'NextRealityCol — Interactive VR experience for Oculus Quest 3 for children.',
    },
    skills: {
      heading: 'Skills',
      title: 'These are the technologies used to build my products.',
    },
    builtProjects: {
      heading: 'Projects',
      title: 'My journey building solutions, software products, and interactive experiences.',
      viewAll: 'View all projects',
    },
    contact: {
      heading: 'Contact',
      title: 'Let\'s connect.',
      subtitle: 'Join me on my journey of creativity and innovation! Follow me to stay updated with my latest projects, insights and adventures.',
      sendMessage: 'Send me a message',
      formName: 'Name',
      formEmail: 'Email',
      formMessage: 'Message',
      formSend: 'Send',
      formSending: 'Sending...',
      formSuccess: 'Message sent! I\'ll get back to you soon.',
      formError: 'Something went wrong. Please try again.',
    },
    projects: {
      heading: 'Projects',
      title: 'A collection of projects combining software, AI, 3D and creativity.',
      easypedido: {
        role: 'Full Stack Developer / AI Engineer',
        period: '2024 – Present · Cali, Colombia',
        summary: '2 years of experience as a Full Stack Developer, participating in the development, maintenance and evolution of a delivery platform, with responsibilities in web development, artificial intelligence, automation, infrastructure and technical support.',
        webTitle: 'Web & Reports',
        webDesc: 'Development of the comprehensive reporting system and maintenance of functionalities with React and TypeScript.',
        backendTitle: 'Backend & Real-time',
        backendDesc: 'Backend development with Django and GraphQL, integrating Firebase and WebSockets for messaging and real-time communication.',
        aiTitle: 'AI & Agents',
        aiDesc: 'Development of AI solutions and autonomous agents using Google ADK, RAG, embeddings, tools, multiple agents and prompt engineering.',
        ariaTitle: 'ArIA — AI for customer support',
        ariaDesc: 'Design and development of ArIA, an AI agent integrated with WhatsApp and n8n, capable of processing text, audio and images, understanding context, performing semantic searches and managing responses autonomously. Integration via MCP with EasyPedido\'s internal logic, enabling querying information and executing actions with permission validation.',
        domiTitle: 'Domi — Intelligent delivery agent',
        domiDesc: 'Development of Domi, an intelligent agent for delivery management based on Google ADK, RAG, multiple agents, tools and embeddings.',
        imageAiDesc: 'Implementation of AI image analysis to generate digital menus from photographs and structure information for database insertion.',
        desktopTitle: 'Desktop & Support',
        desktopDesc: 'Development of a desktop application based on the web app for managing alerts and communication with client devices. Training and technical support for restaurant, veterinary and other business users.',
      },
      toyAventura: {
        badge: 'NextRealityCol · 2026 · Oculus Quest 3',
        title: 'ToyAventuraCali',
        subtitle: 'VR Experience',
        summary: 'Development of an interactive virtual reality experience for NextRealityCol for Oculus Quest 3 headsets, aimed at children aged 7 to 8, combining narrative, puzzles and cultural elements of the city of Cali.',
        gameplayTitle: 'Gameplay & Puzzles',
        gameplayDesc: 'Development of an educational virtual reality videogame using Unity and Oculus Quest 3, with mechanics and puzzles adapted for children.',
        narrativeTitle: 'Narrative',
        narrativeDesc: 'Design of a narrative experience where the player takes the role of a toy that comes to life, exploring the room and solving puzzles to return to their shelf before being discovered.',
        cultureTitle: 'Cali Culture',
        cultureDesc: 'Integration of Colombian historical characters and cultural references from Cali, including the Gato del Río and his girlfriends.',
        modelingTitle: '3D Assets',
        modelingDesc: 'Modeling and creation of 3D resources using Blender, subsequently integrating them into Unity.',
        testingTitle: 'Testing & Tools',
        testingDesc: 'Implementation and testing of the experience through Oculus Quest Developer Hub. Use of Cursor as a support tool for development.',
      },
      university: {
        title: 'University Projects',
        institution: 'Universidad Autónoma de Occidente',
      },
    },
    certifications: {
      heading: 'Certifications',
      title: 'Certifications & Courses.',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      projects: 'Proyectos',
      contact: 'Contacto',
      certifications: 'Certificados',
    },
    hero: {
      eyebrow: 'Diego Galán',
      title: 'Ingeniero de Software construyendo productos',
      highlight: 'impulsados por IA',
      titleEnd: '',
      subtitle: 'Construyo aplicaciones web escalables, agentes de IA inteligentes y experiencias 3D interactivas que resuelven problemas reales.',
      cta1: 'Ver mi trabajo',
      cta2: 'Contáctame',
      ctaCv: 'Descargar CV',
    },
    chat: {
      placeholder: 'Pregúntame lo que quieras de Diego',
      send: 'Enviar',
      suggestions: [
        '¿En qué trabaja Diego?',
        'Dime un dato curioso',
        '¿Qué tecnologías usa?',
      ],
      error: 'No pude responder. Inténtalo en un momento.',
    },
    experience: {
      heading: 'Experiencia',
      title: 'Mi recorrido construyendo soluciones productos de software y experiencias interactivas.',
      t2018title: 'Proyectos Universitarios',
      t2018desc: 'Ingeniería Multimedia — Videojuegos VR, modelado 3D y experiencias interactivas.',
      t2024title: 'Desarrollador Full Stack',
      t2024desc: 'EasyPedido — Desarrollo full-stack de funcionalidades para ecommerce, reportes y sistemas en tiempo real.',
      t2026title: 'Desarrollo VR',
      t2026desc: 'NextRealityCol — Experiencia VR interactiva para Oculus Quest 3 orientada a niños.',
    },
    skills: {
      heading: 'Habilidades técnicas',
      title: 'Estas son las tecnologías que uso para crear mis productos.',
    },
    builtProjects: {
      heading: 'Proyectos',
      title: 'Proyectos que representan mi evolución entre tecnología, creatividad e innovación.',
      viewAll: 'Ver todos los proyectos',
    },
    contact: {
      heading: 'Contacto',
      title: 'Conectemos.',
      subtitle: '¡Acompáñame en mi camino de creatividad e innovación! Sígueme para estar al tanto de mis últimos proyectos, ideas y aventuras.',
      sendMessage: 'Envíame un mensaje',
      formName: 'Nombre',
      formEmail: 'Correo electrónico',
      formMessage: 'Mensaje',
      formSend: 'Enviar',
      formSending: 'Enviando...',
      formSuccess: '¡Mensaje enviado! Te responderé pronto.',
      formError: 'Algo salió mal. Inténtalo de nuevo.',
    },
    projects: {
      heading: 'Proyectos',
      title: 'Una colección de proyectos que combinan software, IA, 3D y creatividad.',
      easypedido: {
        role: 'Desarrollador Full Stack / Ingeniero IA',
        period: '2024 – Actualidad · Cali, Colombia',
        summary: '2 años de experiencia como Desarrollador Full Stack, participando en el desarrollo, mantenimiento y evolución de una plataforma de domicilios, con responsabilidades en desarrollo web, inteligencia artificial, automatización, infraestructura y soporte técnico.',
        webTitle: 'Web & Reportes',
        webDesc: 'Desarrollo del sistema integral de reportes y mantenimiento de funcionalidades con React y TypeScript.',
        backendTitle: 'Backend & Tiempo Real',
        backendDesc: 'Desarrollo backend con Django y GraphQL, integrando Firebase y WebSockets para mensajería y comunicación en tiempo real.',
        aiTitle: 'IA & Agentes',
        aiDesc: 'Desarrollo de soluciones de IA y agentes autónomos utilizando Google ADK, RAG, embeddings, tools, múltiples agentes e ingeniería de prompting.',
        ariaTitle: 'ArIA — IA para atención al cliente',
        ariaDesc: 'Diseño y desarrollo de ArIA, agente de IA integrado con WhatsApp y n8n, capaz de procesar texto, audio e imágenes, comprender contexto, realizar búsquedas semánticas y gestionar respuestas de forma autónoma. Integración mediante MCP con la lógica interna de EasyPedido, permitiendo consultar información y ejecutar acciones con validación de permisos.',
        domiTitle: 'Domi — Agente inteligente de domicilios',
        domiDesc: 'Desarrollo de Domi, agente inteligente para gestión de domicilios basado en Google ADK, RAG, múltiples agentes, tools y embeddings.',
        imageAiDesc: 'Implementación de análisis de imágenes con IA para generar menús digitales a partir de fotografías y estructurar la información para su inserción en base de datos.',
        desktopTitle: 'Escritorio & Soporte',
        desktopDesc: 'Desarrollo de una aplicación de escritorio basada en la aplicación web para gestionar alertas y comunicación con dispositivos de clientes. Capacitación y soporte técnico a usuarios de restaurantes, veterinarias y otras empresas.',
      },
      toyAventura: {
        badge: 'NextRealityCol · 2026 · Oculus Quest 3',
        title: 'ToyAventuraCali',
        subtitle: 'Experiencia VR',
        summary: 'Desarrollo de una experiencia interactiva de realidad virtual para NextRealityCol para gafas Oculus Quest 3, orientada a niños de 7 a 8 años, combinando narrativa, acertijos y elementos culturales de la ciudad de Cali.',
        gameplayTitle: 'Gameplay & Acertijos',
        gameplayDesc: 'Desarrollo de un videojuego educativo en realidad virtual utilizando Unity y Oculus Quest 3, con mecánicas y acertijos adaptados para niños.',
        narrativeTitle: 'Narrativa',
        narrativeDesc: 'Diseño de una experiencia narrativa donde el jugador asume el papel de un juguete que cobra vida, explorando el cuarto y resolviendo acertijos para regresar a su estantería antes de ser descubierto.',
        cultureTitle: 'Cultura Caleña',
        cultureDesc: 'Integración de personajes históricos colombianos y referentes culturales de Cali, incluyendo el Gato del Río y sus novias.',
        modelingTitle: 'Assets 3D',
        modelingDesc: 'Modelado y creación de recursos 3D utilizando Blender, integrándolos posteriormente en Unity.',
        testingTitle: 'Testing & Herramientas',
        testingDesc: 'Implementación y pruebas de la experiencia mediante Oculus Quest Developer Hub. Uso de Cursor como herramienta de apoyo para el desarrollo.',
      },
      university: {
        title: 'Proyectos Universitarios',
        institution: 'Universidad Autónoma de Occidente',
      },
    },
    certifications: {
      heading: 'Certificados',
      title: 'Certificaciones y Cursos.',
    },
  },
};

export default ui;
